<template>
  <div>
    <div class="grid gap-y-2 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
      <div class="panel">
        <div class="panel-body">
          <Summary :data="summary" />
        </div>
      </div>

      <div class="panel">
        <div class="panel-body">
          <reasons-discard :series="discarded_series" :labels="discarded_labels" />
        </div>
      </div>
    </div>
    <div class="grid gap-y-6 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
      <div class="panel">
        <div class="panel-body">
          <harvest-monthly :data="harvests_monthly" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <accepted-discarded :data="totals_monthly" />
        </div>
      </div>
      <div class="panel" v-if="Object.keys(crop_sizes).length > 1">
        <div class="panel-body">
          <crop-sizes :data="crop_sizes" />
        </div>
      </div>
      <div class="panel" v-if="Object.keys(crop_size_packages).length > 1">
        <div class="panel-body">
          <crop-size-packages :data="crop_size_packages" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Summary from "@/components/views/agro_exporter/production/query_by_provider/charts/Summary.vue";
import ReasonsDiscard from "@/components/views/agro_exporter/production/query_by_provider/charts/ReasonsDiscard.vue";
import HarvestMonthly from "@/components/views/producer/reporting/process/charts/HarvestMonthly.vue";
import AcceptedDiscarded from "@/components/views/agro_exporter/production/query_by_provider/charts/AcceptedDiscarded.vue";
import CropSizes from "@/components/views/agro_exporter/production/query_by_provider/charts/CropSizes.vue";
import CropSizePackages from "@/components/views/agro_exporter/production/query_by_provider/charts/CropSizePackages.vue";
export default {
  name: "PRODReportingProcessShowReportsSummary",
  components: {
    Summary,
    ReasonsDiscard,
    HarvestMonthly,
    AcceptedDiscarded,
    CropSizes,
    CropSizePackages
  },
  props: {
    provider_id: { required: true },
    provider_type: { required: true },
    agro_exporter_process_id: { required: true },
    summary: { required: true },
    discarded_motives: { required: true },
    harvests_monthly: { required: true },
    totals_monthly: { required: true },
    crop_sizes: { required: true },
    crop_size_packages: { required: true }
  },
  data() {
    return {
      // Motivos descarte
      seriesM: this.discarded_motives
    };
  },
  computed: {
    series() {
      return [
        {
          name: "",
          data: this.data_weekly
        }
      ];
    },
    discarded_series() {
      return this.discarded_motives.map(dm => dm.value);
    },
    discarded_labels() {
      return this.discarded_motives.map(dm => dm.name);
    }
  }
};
</script>
